const REQUEST_CACHE = {};

export default REQUEST_CACHE;
